import * as React from 'react';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { ISettings } from 'components/settings/model/Settings';
import { ViewBillTipSelectorItem } from './ViewBillTipSelectorItem';

const StyledBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: theme.shape.borderRadius,
    marginTop: theme.spacing(1),
    overflow: 'hidden'
}));

interface IProps {
    tipping: ISettings['tipping'];
    onTipOptionSelected: (value: number) => void;
    selected: number | null;
}

export const ViewBillTipSelector: React.FC<React.PropsWithChildren<IProps>> = ({
    tipping: { scheme, values },
    selected,
    onTipOptionSelected
}) => {
    const tipSelectorOptions = React.useMemo(
        () =>
            values.map((tipValue, index) => (
                <ViewBillTipSelectorItem
                    value={tipValue}
                    key={tipValue}
                    isLast={values.length - 1 === index}
                    scheme={scheme}
                    onClick={onTipOptionSelected}
                    selected={tipValue === selected}
                />
            )),
        [onTipOptionSelected, scheme, selected, values]
    );

    return <StyledBox>{tipSelectorOptions}</StyledBox>;
};
